import './stack.css';
export default {
  "modifiers": {
    "fill": "pf-m-fill",
    "gutter": "pf-m-gutter"
  },
  "stack": "pf-v6-l-stack",
  "stackItem": "pf-v6-l-stack__item"
};